import type { ILoanRepaymentTemplateForm } from "@/modules/template/common/types";
import { loanRepaymentTemplateValidationSchema } from "@/modules/template/validations";
import type { IOperationPageProps } from "@/shared/common/types";
import { PageHeader } from "@/shared/components";
import { useTranslationExists } from "@/shared/hooks";
import { FormContainer } from "@ab.uitools/ui-library/components/FormContainer";

import { LoanRepaymentTemplateForm } from "./LoanRepaymentTemplateForm";

export const LoanRepaymentTemplate = ({ isEdit }: IOperationPageProps) => {
  const { t } = useTranslationExists();

  const initialValues: ILoanRepaymentTemplateForm = {
    loanContractNumber: "",
    loanRepaymentType: "",
    debitAccount: "",
    amount: "",
    name: "",
    purpose: "",
  };

  return (
    <FormContainer
      className="full-width page-container form-layout loan-repayment"
      formId="form-container"
      mode="onBlur"
      reValidateMode="onBlur"
      initialValues={initialValues}
      validationScheme={loanRepaymentTemplateValidationSchema({ t })}
    >
      <PageHeader/>
      <LoanRepaymentTemplateForm isEdit={isEdit}/>
    </FormContainer>
  );
};
